import React from 'react'
import Link from 'gatsby-link'

import {Icon} from 'react-fa'

import { stack as Menu } from 'react-burger-menu'

let menuStyles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px',
		color: '#2b2b2b',
		textShadow: '-2px 0 #ffffff, 0 2px #ffffff, 2px 0 #ffffff, 0 -2px #ffffff'
  },
  bmBurgerBars: {
    background: '#373a47'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: 'red'
  },
  bmMenu: {
    background: '#2b2b2b',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
		height: '119%'
  },
  bmMorphShape: {
    fill: '#373a47'
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
		height: '119%'
  }
}

let menuIconStyle = {
    textShadow: '-1px 0 #4169E1, 0 1px #4169E1, 1px 0 #4169E1, 0 -1px #4169E1'
}

let linkStyles = {
	display: 'block',
	outline: 'none',
	padding: '0.8em',
	color: '#ffffff'
}

let linkStylesActive = {
	display: 'block',
	outline: 'none',
	padding: '0.8em',
	color: '#000000',
	backgroundColor: '#D0D0D0',
	borderRadius: '5px'
}

let iconStylefamily = {
	opacity: '0.5',
	fontSize: '1.6em'
}

let iconStyle = {
	opacity: '0.5',
	width: '30px'
}

let menuTextStyleFamily = {
	marginLeft: '20px',
	fontWeight: '700'
}

let menuTextStyle = {
	marginLeft: '10px',
	fontWeight: '700'
}

class SiteNavi extends React.Component {
  render() {
    const { location } = this.props
    const { title } = this.props
    return (
			<div>
				<Menu
					styles={ menuStyles }
					isOpen={ false }
					customBurgerIcon={ <Icon name="bars" size="3x" />}
					customCrossIcon={ <Icon name="times" /> }
				>
					<Link to="/"
								style={ location.pathname === '/' ? linkStylesActive : linkStyles }
								>
						<span className="icon icon-w" style={ iconStylefamily  }></span> <span style={ menuTextStyleFamily } >Home</span>
					</Link>

					<Link to="/projects"
								style={ location.pathname === '/projects' ? linkStylesActive : linkStyles }
								>
						<Icon name="cubes" style={ iconStyle } /> <span style={ menuTextStyle } >Projects</span>
					</Link>

					<Link to="/contact"
								style={ location.pathname === '/contact' ? linkStylesActive : linkStyles }
								>
						<Icon name="hand-spock-o" style={ iconStyle } /> <span style={ menuTextStyle } >Contact</span>
					</Link>

{/*
          <Link to="/curriculumvitae"
								style={ location.pathname === '/curriculumvitae' ? linkStylesActive : linkStyles }
								>
						<Icon name="cube" style={ iconStyle } /> <span style={ menuTextStyle } >CV</span>
					</Link>
*/}

					<a href="http://blog.christian-wolter.com" style={ linkStyles } >
						<Icon name="rss" style={ iconStyle } /> <span style={ menuTextStyle } >Blog</span>
					</a>
	      </Menu>
	    </div>
    )
  }
}

export default SiteNavi



// WEBPACK FOOTER //
// ./src/components/SiteNavi/index.jsx